import React, { useEffect, useState } from "react";

import {
    getEarnings,
    getEarningStats,
    getRevenueChart,
    getTopProviders,
} from "../services/adminApi";

import EarningHeader from "../components/earnings/EarningHeader";
import EarningStats from "../components/earnings/EarningStats";
import RevenueChart from "../components/earnings/RevenueChart";
import CommissionTable from "../components/earnings/CommissionTable";
import TopProviders from "../components/earnings/TopProviders";
import PaymentSummary from "../components/earnings/PaymentSummary";
import SettlementSummary from "../components/earnings/SettlementSummary";

import "../styles/Earnings.css";

const Earnings = () => {

    const [earnings, setEarnings] = useState([]);
    const [stats, setStats] = useState({});
    const [chart, setChart] = useState([]);
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {

        try {

            const [
                earningsRes,
                statsRes,
                chartRes,
                providersRes,
            ] = await Promise.all([
                getEarnings(),
                getEarningStats(),
                getRevenueChart(),
                getTopProviders(),
            ]);

            setEarnings(earningsRes.data.earnings || []);
            setStats(statsRes.data.stats || {});
            setChart(chartRes.data.chart || []);
            setProviders(providersRes.data.providers || []);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="earnings-page">

            <EarningHeader />

            <EarningStats stats={stats} />

            <RevenueChart data={chart} />

            <CommissionTable
                earnings={earnings}
                loading={loading}
            />

            <div className="earnings-bottom">

                <TopProviders
                    providers={providers}
                />

                <PaymentSummary
                    earnings={earnings}
                />

                <SettlementSummary
                    earnings={earnings}
                />

            </div>

        </div>

    );

};

export default Earnings;